import { render, staticRenderFns } from "./BankUpdate.vue?vue&type=template&id=39945682&"
import script from "./BankUpdate.vue?vue&type=script&lang=js&"
export * from "./BankUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports